import moment from "moment-timezone";

const getUserTimeZone = (tzString) => {
  const zone = tzString || "UTC";
  const zonedNow = moment.tz(zone);
  const offset = zonedNow.utcOffset();
  const abbr = zonedNow.zoneAbbr();
  return {
    zone,
    offset,
    abbr,
  };
};

export default getUserTimeZone;
